import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Merge Tailwind classes, last-write-wins on conflicts. Used by every shadcn component. */
export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
